import React from 'react'

const About = () => {
    return (
        <section className="about section" id="about">
            <h2 className="section__title">About Me</h2>
            <span className="section__subtitle">My Introduction</span>

            <div className="about__container container grid">
                <img src="./assets/profil2.png" alt="MyProfilImg" className="about__img"/>

                    <div className="about__data">
                        <p className="about__description">
                            Web developer, with extensive knowledge and yers of experience, working in Web
                            technologies and UI / UX design, delivering quality work.
                        </p>

                        <div className="about__info">
                            <div>
                                <span className="about__info-title">02+</span>
                                <span className="about__info-name">Years <br/> experience</span>
                            </div>

                            <div>
                                <span className="about__info-title">03+</span>
                                <span className="about__info-name">Completed <br/> project</span>
                            </div>

                            <div>
                                <span className="about__info-title">02+</span>
                                <span className="about__info-name">Companies <br/> worked</span>
                            </div>
                        </div>

                        <div className="about__buttons">
                            <a download="" href="./assets/SahobisoaRolland_CV.pdf" className="button button--flex">
                                Download CV <i className="uil uil-download-alt button__icon"></i>
                            </a>
                        </div>
                    </div>
            </div>
        </section>
    )
}

export default About